import {KeyValuePair} from "../Global/KeyValuePair";

interface INewNonceResult {
    nonce: string;
    validTo: string; // DateTime
}

export default class CaptchaTokenManager {
    private token: INewNonceResult;
    private validityToleranceMs = 3000;

    private readonly CaptchaTokenHeaderNonceName = "X-Captcha-Token-Nonce";
    private readonly CaptchaTokenParameterName = "CaptchaToken";

    public init(jq: JQueryStatic): void {
        const oldFetch = window.fetch;  // must be on the global scope
        window.fetch = async (url, options) => {
            const response = await oldFetch(url, options);
            const tokenNonce = response.headers.get(this.CaptchaTokenHeaderNonceName);
            const tokenValidTo = response.headers.get("X-Captcha-Token-ValidTo");
            if (tokenNonce && tokenValidTo) {
                this.token = {
                    nonce: tokenNonce,
                    validTo: tokenValidTo,
                };
            }
            return response;
        };

        jq(document).ajaxComplete((event, request, settings) => {
            const tokenNonce = request.getResponseHeader(this.CaptchaTokenHeaderNonceName);
            const tokenValidTo = request.getResponseHeader("X-Captcha-Token-ValidTo");

            if (tokenNonce && tokenValidTo) {
                this.token = {
                    nonce: tokenNonce,
                    validTo: tokenValidTo,
                };
            }
        });

    }

    public getTokenParam(): KeyValuePair<string, string> {
        if (this.token && new Date().getTime() + this.validityToleranceMs <= new Date(this.token.validTo).getTime()) {
            return [this.CaptchaTokenParameterName, this.token.nonce];
        }
        return null;
    }
}
